import React, { useEffect, useState, useRef } from "react";
export default function VonageSpotlightView(props) {
  const [videoCount, setVideoCount] = useState(0);
  const [gridClass, setGridClass] = useState("one-row");
  const [currentSpotlights, setCurrentSpotlights] = useState([]);
  const functionsRef = useRef();
  const { hubConnection, checkSpotlightLayoutStatus } = props;
  useEffect(() => {
    functionsRef.current = {
      currentSpotlights: [...currentSpotlights],
      toggleSpotlightView,
      onStreamConnected,
      onStreamDisconnected,
    };

    if (hubConnection) {
      hubConnection.on("onVonageGetSpotlights", onVonageGetSpotlights);
    }
    return () => {
      if (hubConnection) {
        hubConnection.off("onVonageGetSpotlights", onVonageGetSpotlights);
      }
    };
  });
  useEffect(() => {
    if (props.layoutMode == "spotlight") {
      toggleSpotlightView();
    }
    checkSpotlightLayoutStatus();
  }, [currentSpotlights]);
  useEffect(() => {
    props.setFunctionsRef(functionsRef);
    hubConnection.invoke("vonageGetSpotlights", props.eventId, props.channel);
  }, []);

  function onVonageGetSpotlights(spotlightList) {
    setCurrentSpotlights(spotlightList);
  }
  useEffect(() => {
    if (videoCount <= 1) {
      setGridClass("one-row-single");
    } else if (videoCount == 2) {
      setGridClass("one-row");
    } else if (videoCount > 2 && videoCount <= 4) {
      setGridClass("two-row");
    } else if (videoCount >= 5 && videoCount <= 9) {
      setGridClass("three-row");
    } else if (videoCount >= 10 && videoCount <= 13) {
      setGridClass("three-row wide");
    } else if (videoCount >= 13 && videoCount < 17) {
      setGridClass("four-row");
    } else {
      setGridClass("five-row");
    }
  }, [videoCount]);

  function toggleSpotlightView() {
    const { streams, publisher } = props;
    const containerDiv = document.getElementById("vonage-spotlight-container");
    const hiddenDiv = document.getElementById("vonage-spotlight-hidden");
    let vidCount = 0;
    if (publisher && publisher.stream) {
      if (publisher.stream.name && currentSpotlights.includes(publisher.stream.name)) {
        containerDiv.append(publisher.element);
        vidCount += 1;
      } else {
        hiddenDiv.append(publisher.element);
      }
    }
    for (const subscriber of streams) {
      if (currentSpotlights.indexOf(subscriber.stream?.name) != -1) {
        vidCount += 1;
        if (typeof subscriber.subscribeToVideo == "function") subscriber.subscribeToVideo(true);
        containerDiv.append(subscriber.element);
      } else {
        if (typeof subscriber.subscribeToVideo == "function") subscriber.subscribeToVideo(false);
        hiddenDiv.append(subscriber.element);
      }
    }
    if (videoCount != vidCount) setVideoCount(vidCount);

    // props.checkSpotlightLayout();
  }
  function onStreamConnected(subscriber) {
    checkSpotlightLayoutStatus();
    if (props.layoutMode == "spotlight") {
      toggleSpotlightView();
    }
  }
  function onStreamDisconnected(subscriber) {
    checkSpotlightLayoutStatus();
    if (props.layoutMode == "spotlight") {
      toggleSpotlightView();
    }
  }

  return (
    <div id="vonage-spotlight-wrap" style={{ display: props.layoutMode == "spotlight" ? "flex" : "none" }}>
      <div className={gridClass} id={"vonage-spotlight-container"}></div>
      <div ref={(r) => props.setHiddenRef(r)} id="vonage-spotlight-hidden" style={{ display: "none" }}></div>
    </div>
  );
}
